import { render, staticRenderFns } from "./GraficoRankingTipoLead.vue?vue&type=template&id=350f888d&scoped=true"
import script from "./GraficoRankingTipoLead.vue?vue&type=script&lang=ts"
export * from "./GraficoRankingTipoLead.vue?vue&type=script&lang=ts"
import style0 from "./GraficoRankingTipoLead.vue?vue&type=style&index=0&id=350f888d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f888d",
  null
  
)

export default component.exports